export default Object.freeze({
    GENERAL: 'GENERAL',
    ACO: 'ACO',
    CMP: 'CMP',
    PCP: 'PCP',
})
